export default (Vue)=>{
    Vue.directive("focus", {
        inserted: function (el) {
            el.focus(); 
        }
    })
				
				Vue.directive('title', {
				  inserted: function (el, binding) {
				    document.title = el.dataset.title
				  }
				});
				 
}